import { render, staticRenderFns } from "./EditClientModel.vue?vue&type=template&id=2e6f85c8&scoped=true"
import script from "./EditClientModel.vue?vue&type=script&lang=js"
export * from "./EditClientModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f85c8",
  null
  
)

export default component.exports